import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { House, Users, ChartLineUp, SignOut, MapPin, Gear, UsersThree } from "@phosphor-icons/react";
import { Toaster } from "sonner";

export default function Layout({ children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const isAdmin = user?.role === "admin";

    const nav = [
        { to: "/", label: "Tableau de bord", icon: ChartLineUp, adminOnly: false },
        { to: "/clients", label: "Clients", icon: Users, adminOnly: false },
        { to: "/cites", label: "Cités", icon: MapPin, adminOnly: false },
        { to: "/utilisateurs", label: "Utilisateurs", icon: UsersThree, adminOnly: true },
        { to: "/parametres", label: "Paramètres", icon: Gear, adminOnly: true },
    ].filter((n) => !n.adminOnly || isAdmin);

    return (
        <div className="min-h-screen bg-cream">
            <Toaster position="top-right" richColors />
            <aside className="fixed top-0 left-0 h-screen w-64 bg-white border-r border-sand flex flex-col">
                <div className="p-6 border-b border-sand">
                    <div className="flex items-center gap-3">
                        <div
                            className="w-10 h-10 rounded-xl bg-terracotta text-white grid place-items-center font-display font-bold text-lg"
                            data-testid="brand-logo"
                        >
                            <House weight="fill" size={20} />
                        </div>
                        <div>
                            <p className="font-display font-bold text-ink leading-tight">Terra CRM</p>
                            <p className="text-xs text-ink-soft tracking-wider uppercase">Immobilier</p>
                        </div>
                    </div>
                </div>

                <nav className="flex-1 p-4 space-y-1">
                    {nav.map(({ to, label, icon: Icon }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={to === "/"}
                            data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 rounded-md transition-all ${
                                    isActive
                                        ? "bg-terracotta text-white shadow-[0_2px_8px_rgba(200,107,82,0.25)]"
                                        : "text-ink hover:bg-cream"
                                }`
                            }
                        >
                            <Icon size={18} weight="duotone" />
                            <span className="text-sm font-medium">{label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="p-4 border-t border-sand">
                    <div className="px-2 pb-3">
                        <p className="text-xs text-ink-soft uppercase tracking-widest">Connecté</p>
                        <p className="text-sm font-medium text-ink truncate" data-testid="user-email">
                            {user?.email}
                        </p>
                        <p className="text-[10px] uppercase tracking-widest text-terracotta mt-0.5" data-testid="user-role">
                            {isAdmin ? "Administrateur" : "Commercial"}
                        </p>
                    </div>
                    <button
                        data-testid="logout-button"
                        onClick={async () => {
                            await logout();
                            navigate("/login");
                        }}
                        className="w-full flex items-center gap-2 px-4 py-2.5 rounded-md text-sm text-ink hover:bg-cream transition-colors"
                    >
                        <SignOut size={18} />
                        Se déconnecter
                    </button>
                </div>
            </aside>
            <main className="ml-64 p-8">{children}</main>
        </div>
    );
}
